import { ApplicationElement, html } from '../application_element/element.js';
import translations from './translations.js';
import style from './style.lit.css';
import '../icon_block/element.js';

/**
 * Time range with different format depending on same day, same month or same year range
 */
export default class TimeRange extends ApplicationElement {
  static properties = {
    from: { type: Date },
    to: { type: Date },
    dateOnly: { type: Boolean },
    hideIcon: { type: Boolean },
  };

  static styles = [ApplicationElement.styles, style];

  /** @internal */
  static translations = translations;

  /** @internal */
  get sameYear() {
    return this.from.getFullYear() === this.to.getFullYear();
  }

  /** @internal */
  get sameMonth() {
    return this.from.getMonth() === this.to.getMonth();
  }

  /** @internal */
  get sameDay() {
    return this.from.getDate() === this.to.getDate();
  }

  /** @internal */
  get range() {
    let date;
    if (this.sameYear && this.sameMonth && this.sameDay) {
      date = this.dateOnly
        ? this.t('all_day')
        : this.translateToFormat('time.formats.time');
    } else if (this.sameYear) {
      date = this.dateOnly
        ? this.translateToFormat('date.formats.short')
        : this.translateToFormat('time.formats.short');
    } else {
      date = this.dateOnly
        ? this.translateToFormat('time.formats.date')
        : this.translateToFormat('time.formats.long2');
    }
    return date;
  }

  /** @internal */
  translateToFormat(format) {
    return `${this.i18n.l(format, this.from)} - ${this.i18n.l(
      format,
      this.to
    )}`;
  }

  /** @internal */
  renderRangeWithIcon() {
    return html`
      <ef-icon-block icon="clock" text=${this.range}></ef-icon-block>
    `;
  }

  render() {
    return html` ${this.hideIcon ? this.range : this.renderRangeWithIcon()} `;
  }
}

TimeRange.registerTagName('ef-time-range');

customElements.get('ef-time-range') ||
  customElements.define('ef-time-range', TimeRange);
